var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnlockFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_564_50253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9.99863H20C20.2652 9.99863 20.5196 10.104 20.7071 10.2915C20.8946 10.4791 21 10.7334 21 10.9986V20.9986C21 21.2638 20.8946 21.5182 20.7071 21.7057C20.5196 21.8933 20.2652 21.9986 20 21.9986H4C3.73478 21.9986 3.48043 21.8933 3.29289 21.7057C3.10536 21.5182 3 21.2638 3 20.9986V10.9986C3 10.7334 3.10536 10.4791 3.29289 10.2915C3.48043 10.104 3.73478 9.99863 4 9.99863H5V8.99863C4.99943 7.42133 5.53158 5.89007 6.51019 4.65306C7.4888 3.41605 8.8565 2.54581 10.3916 2.18339C11.9267 1.82097 13.5392 1.98762 14.9677 2.65634C16.3963 3.32505 17.5571 4.45662 18.262 5.86763L16.473 6.76163C15.9695 5.75364 15.1403 4.94527 14.1198 4.46757C13.0994 3.98987 11.9475 3.87085 10.8509 4.1298C9.7543 4.38875 8.77733 5.0105 8.07836 5.89423C7.37939 6.77797 6.9994 7.87188 7 8.99863V9.99863ZM10 14.9986V16.9986H14V14.9986H10Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_50253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlockFill);
export default __webpack_public_path__ + "static/media/icon-unlock-fill.3a3e96405c0f656711d6bacd88a99f82.svg";
export { ForwardRef as ReactComponent };